<template>
  <div>
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        label="标签序号"
        :resizable="false"
        width="180">
        <template slot-scope="{row}">
          {{ row.beginTagNo | tagCount() }} - {{ row.endTagNo | tagCount() }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="产品线"
        :resizable="false"
        prop="productLineName">
      </el-table-column> -->
      <el-table-column
        label="标签数量"
        :resizable="false"
        prop="tagCount">
      </el-table-column>
      <el-table-column
        label="剩余数量"
        :resizable="false"
        prop="remainCount">
      </el-table-column>
      <el-table-column
        label="生产时间"
        :resizable="false"
        width="140">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat() }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :resizable="false"
        width="95">
        <template slot-scope="{row}">
          <el-button
            type="success"
            icon="el-icon-download"
            @click="downloadtagsegment(row)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="gettagassigns" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'LabelTagDetailModal',
  components: { },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        isPreassign: 1,
        isSetcode: 0
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  mounted() {
    this.gettagassigns()
  },
  methods: {
    downloadtagsegment(row) {
      this.loading = true
      this.$store.dispatch('label/downloadtagsegment', {
        payload: {
          tagSegId: row.tagSegId,
          tagSegDetailsId: row.tagSegDetailsId
        },
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    gettagassigns() {
      this.loading = true
      this.$store.dispatch('label/gettagsegmentdetailses', {
        payload: {
          ... this.config,
          vendorId: this.userInfo.orgId
        },
        success: (res) => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.gettagassigns()
    }
  }
}
</script>
